import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Fit2Fin from "@/pages/Fit2Fin";
import Fit2FinDifferent from "@/pages/Fit2FinDifferent";
import CricStoryLive from "@/pages/CricStoryLive";
import SalaryAI from "@/pages/SalaryAI";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/fit2fin" element={<Fit2Fin />} />
            <Route path="/fit2fin/why-different" element={<Fit2FinDifferent />} />
            <Route path="/cricstorylive" element={<CricStoryLive />} />
            <Route path="/salaryai" element={<SalaryAI />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
